export const INITIAL_STATE = {
  isAuth: false,
  signup: {
    message: '',
  },
  loading: false,
};
